// extracted by mini-css-extract-plugin
export default {"root":"ETTgohq9","glowPink":"wwEBLzO0","glowBlue":"hYmY2cgL"};